import type { Building } from "building-types/building/buildingTypes";
import colors from "common/constants/colorsOld";
import { generateRect, rectDefault } from "lib/house/annotation/Rect";
import type { BuiltInDataTable, BuiltInDataTableCell } from "lib/house/dataSequences/dataTableTypes";
import { getFloorMaterialKeyMeasures } from "./floorMaterial";

export function makeFloorMaterialSummaryDataTable(building?: Building | undefined): BuiltInDataTable {
  if (!building) {
    return {
      type: "FLOOR_MATERIALS_SUMMARY",
      name: "Flooring Materials Summary",
      headers: ["LEGEND", "MATERIAL", "TOTAL AREA"],
      rows: [],
      countsByFloor: {},
      footnote: "",
    };
  }

  const floorMaterialRows = selectFloorMaterialSummaryRows(building);
  const rows = formatFloorMaterialSummaryRows(floorMaterialRows);
  return {
    type: "FLOOR_MATERIALS_SUMMARY",
    name: "Flooring Materials Summary",
    headers: ["LEGEND", "MATERIAL", "TOTAL AREA"],
    rows,
    countsByFloor: {},
    footnote: "",
  };
}

export const FloorMaterialAreaColorTable: string[] = [
  colors.emerald,
  colors.ruby,
  colors.sapphire,
  colors.gold,
  colors.amethyst,
  colors.stoneLightX1,
  colors.citrineLightX1,
  colors.amberLightX2,
  colors.rubyLightX2,
  colors.stoneLightX5,
];

export function selectFloorMaterialSummaryRows(building: Building) {
  const materialsByRow: { [key: string]: [string, string, string] } = {};

  const floorMaterialKeyMeasures = getFloorMaterialKeyMeasures(building.floorSystems);

  let i = 0;
  for (const key in floorMaterialKeyMeasures) {
    const floorFillColor = FloorMaterialAreaColorTable[i % FloorMaterialAreaColorTable.length];
    materialsByRow[key] = [
      floorMaterialKeyMeasures[key].name,
      `${Math.round(floorMaterialKeyMeasures[key].area)} SF`,
      floorFillColor,
    ];
    i++;
  }

  return Object.values(materialsByRow);
}

function formatFloorMaterialSummaryRows(
  floorMaterialRows: ReturnType<typeof selectFloorMaterialSummaryRows>,
): BuiltInDataTableCell[][] {
  const rows: BuiltInDataTableCell[][] = [];

  for (const row of floorMaterialRows) {
    const tableRow: BuiltInDataTableCell[] = [];
    tableRow.push({
      type: "SYMBOL",
      value: generateRect({
        ...rectDefault,
        fillColor: row[2],
        width: 33,
        height: 33,
        opacity: 0.5,
      }),
    });

    tableRow.push({
      type: "TEXT",
      value: row[0],
    });

    tableRow.push({
      type: "TEXT",
      value: row[1],
    });

    rows.push(tableRow);
  }

  return rows;
}
